var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('Item',{attrs:{"list":_vm.czIscos,"label":_vm.$t('workers.cz_isco')},on:{"add":_vm.addCzIsco,"remove":_vm.removeCzIsco,"edit":_vm.changeCzIsco}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }